// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__flVv4","plus":"styles_plus__m6jxh","key":"styles_key__a_jTk"};